<template>
  <div class="questionnaire-page">
    <!-- 主页 -->
    <div class="mainer-wrap" v-show="showMainer">
      <div class="mainer-detail" :style="{background: `url(${answerInfo.backgroundImage}) center top / 100% no-repeat`}">
        <div class="mainer-desc">{{answerInfo.description}}</div>
        <button :class="['answer-btn', isHigh]" v-if="answerInfo.userStatus === 0" @click="getNewPaper">开始答题</button>
      </div>
    </div>
    <!-- 答题页 -->
    <div class="questionnaire-wrap" v-show="!showMainer && !showResult">
      <swiper-answer ref="swiperAnswer"
        :answerInfo="answerInfo"
        :questions="questions"
        :id="id"
        @updateAnswer="updateAnswer"
        @updateActiveIndex="updateActiveIndex"
        @submitPager="submitPager"></swiper-answer>
    </div>
    <!-- 结果页 -->
    <div class="result-wrap" v-show="showResult">
      <div class="result-detail">
        <div class="score-wrap" v-if="answerInfo.userPaperScore"><span class="score">{{answerInfo.userPaperScore.userScore}}</span><span class="unit">分</span></div>
        <div class="send-word" v-if="answerInfo.userPaperScore">{{answerInfo.userPaperScore.sendWord}}</div>
        <button :class="['retry-btn', isHigh]" @click="reTry">重新测试</button>
      </div>
    </div>
  </div>
</template>

<script>
import swiperAnswer from './components/swiper-answer.vue'
import storeMixin from '../mixins/store'

let startX = null
let endX = null
let move = null

export default {
  props: ['id'],
  data () {
    return {
      answerInfo: {
        userStatus: 0
      },
      userPid: null,
      questions: [],
      swiperToMainer: false,
      swiperToResult: true,
      currentIdx: 0,
      isHigh: 'high'
    }
  },
  computed: {
    showMainer () {
      return this.swiperToMainer || !this.answerInfo.userStatus
    },
    showResult () {
      return this.swiperToResult && this.answerInfo.userStatus === 2
    }
  },
  watch: {
    loginCount: {
      immediate: true,
      handler: function (val) {
        val > 0 && this.getPaper()
      }
    }
  },
  mixins: [storeMixin],
  components: {swiperAnswer},
  methods: {
    getPaper () {
      try {
        this.$rootApi.api(['getPaper', this.id]).then(res => {
          let {code, data, message} = res.data
          if (code === 0) {
            let {questions, userStatus} = data
            this.answerInfo = data
            document.title = data.title
            // this.SET_PAGE_TITLE(data.title)

            this.initShare()
            if (userStatus) {
              questions && questions.forEach(question => {
                if (question.userAnswer) {
                  let {answers, userAnswers, analysis} = question.userAnswer
                  userAnswers.sort((a, b) => a - b)
                  let result = {}
                  question.options.forEach(item => {
                    result[item.id] = item.name
                    if (answers.includes(item.id)) {
                      item.answerType = !userAnswers.includes(item.id) && question.type === 'checkbox'  ? 'right-clean' : 'right'
                    } else if (userAnswers.includes(item.id)) {
                      item.answerType = 'fault'
                    }
                  })
                  question.userAnswer = {
                    answers: answers.map(item => result[item]),
                    userAnswers: userAnswers.map(item => result[item]),
                    analysis
                  }
                  question.isRight = answers.join('') === userAnswers.join('')
                  this.currentIdx++
                }
              })
              this.questions = questions
              this.$nextTick(() => {
                if (this.currentIdx >= data.questionCount) {
                  this.currentIdx--
                }
                userStatus === 1 && this.$refs.swiperAnswer.toQuestion(this.currentIdx)
              })
            } 
          } else {
            this.$toast(message)
          }
        })
      } catch (err) {
        this.$toast(err.message || err)
      }
    },
    toLogin () {
      this.SET_PHONE_LOGIN({type: 'login'})
    },
    // 开始答题
    getNewPaper () {
      if (this.USERINFO.isTourist) {
        this.toLogin()
        return
      }
      if (this.swiperToMainer) {
        this.swiperToMainer = false
      }
      try {
        this.$rootApi.api(['getNewPaper', this.id]).then(res => {
          let {code, data, message} = res.data
          if (code === 0) {
            console.log(data)
            this.questions = data && data.questions
            this.$set(this.answerInfo, 'userStatus', 1)
            this.$set(this.answerInfo, 'userPid', data.userPid)
            this.$nextTick(() => {
              this.$refs.swiperAnswer.toQuestion(0)
            })
          } else {
            this.$toast(message)
          }
        })
      } catch (err) {
        this.$toast(err.message || err)
      }
    },
    updateActiveIndex (idx) {
      this.currentIdx = idx
    },
    // 重新答题
    reTry () {
      // this.getNewPaper()
      this.swiperToMainer = true
      this.answerInfo.userStatus = 0
    },
    // 提交试卷 
    submitPager (data) {
      let {userScore, sendWord} = data
      this.answerInfo =  Object.assign({}, this.answerInfo, {
        userStatus: 2,
        userPaperScore: {
          userScore,
          sendWord
        }
      })
    },
    // 计算答案状态
    updateAnswer (userAnswer, activeIndex, type) {
      let {answers, userAnswers, analysis} = userAnswer
      userAnswers.sort((a, b) => a - b)

      let result = {}
      this.questions[activeIndex].options.forEach(item => {
        result[item.id] = item.name
        if (answers.includes(item.id)) {
          item.answerType = !userAnswers.includes(item.id) && type === 'checkbox'  ? 'right-clean' : 'right'
        } else if (userAnswers.includes(item.id)) {
          item.answerType = 'fault'
        }
      })
      this.$set(this.questions[activeIndex], 'isRight', answers.join('') === userAnswers.join(''))
      this.$set(this.questions[activeIndex], 'userAnswer', {
        answers: answers.map(item => result[item]),
        userAnswers: userAnswers.map(item => result[item]),
        analysis
      })
    },
    startFn (e) {
      let target = e.targetTouches[0]
      startX = target.clientX
    },
    moveFn (e) {
      let target = e.targetTouches[0]
      endX = target.clientX
      move = endX - startX
    },
    endFn () {
      // 右移
      if (move < -60) {
        // 1.主页跳swiper
        if (this.swiperToMainer) {
          this.swiperToMainer = false
          this.$refs.swiperAnswer.toQuestion(0)
          // 2.swiper跳结果页
        } else if (this.currentIdx === this.answerInfo.questionCount - 1 && this.answerInfo.userStatus === 2) {
          this.swiperToResult = true
          // 3.swiper右移
        } else if (this.questions[this.currentIdx].userAnswer) {
          this.$refs.swiperAnswer.nextQuestion()
        }
      }

      // 左移
      if (move > 60) {
        // 1. 结果页跳swiper
        if (this.showResult) {
          this.swiperToResult = false
          this.$nextTick(() => {
            this.$refs.swiperAnswer.toQuestion(this.answerInfo.questionCount - 1)
          })
          // 2.swiper跳主页
        } else if (this.currentIdx === 0) {
          this.swiperToMainer = true
          // 3.swiper左移
        } else if (this.questions[this.currentIdx - 1].userAnswer) {
          this.$refs.swiperAnswer.preQuestion()
        }
      }
      move = null
    },
    initShare () {
      let options = {
        title: this.answerInfo.title,
        desc: '欢迎来到课后小测试，请您认真填写哦，这样有助于您提升学习效率和提升炒股能力',
        imgUrl: 'https://h5-hd.secon.cn/static/images/questionnaire-icon.jpg'
      }
      let url = location.href
      this.wechatShare(options, url, url, () => {})
    }
  },
  mounted () {
    let height = window.screen.height 
    if (this.os == 'ios') {
      this.isHigh = height >= 812 ? 'high-ios' : 'low-ios'
    } else {
      this.isHigh = height >= 812 ? 'high' : 'low'
    }
    // this.isHigh = window.screen.height >= 812 ? 'high' : 'low'
    console.log(this.isHigh)
    window.addEventListener('touchstart', this.startFn)
    window.addEventListener('touchmove', this.moveFn)
    window.addEventListener('touchend', this.endFn, true)
  },
}
</script>

<style lang="stylus" scoped>
.result-wrap
  width 100%
  min-height 100vh
  height 100%
  background: #1e017c
.result-detail
  width 100%
  min-height 100vh
  height 100%
  display: flex
  flex-direction: column
  align-items: center
  background: url(./images/result-bg.jpg) center top / 100% no-repeat
  .score-wrap
    color: #ffffff
    font-weight: 700
    padding-top: 1.6rem
    .score
      font-size: .73rem
      line-height: 1.03rem
    .unit
      font-size: .21rem
      line-height: .29rem
  .send-word
    margin-top: .7rem
    font-size: .16rem
    line-height: .24rem
    text-align: center
    width 2.6rem
  .retry-btn
    position: absolute
    left 50%
    transform: translateX(-50%)
    width: 3.22rem
    height: .54rem
    border-radius: .28rem
    font-size: .16rem
    line-height: .23rem
    font-weight: 700
    color: #ffffff
    background: linear-gradient(to right, #E63546, #FA7738)
    &.high
      bottom 1.66rem
    &.low
      bottom .7rem
    &.high-ios
      bottom .86rem
    &.low-ios
      bottom .25rem
.questionnaire-wrap
  width 100%
  height 100%
  min-height 100vh
  background #3F30DC
  // padding-top .53rem
.questionnaire-page
  width 100%
  min-height 100vh
  font-size .12rem
.mainer-wrap
  width 100%
  height 100%
  min-height 100vh
  background #f79975
  .mainer-detail
    width 100%
    height 100%
    min-height 100vh
    display flex
    flex-direction column
    align-items center
    position relative
    // background: url(./images/answer-bg.png) center top / 100% no-repeat
    .mainer-desc
      text-align center
      margin-top 3.03rem
      width 2.54rem
      // height .4rem
      text-align: justify
      font-size: .14rem
      line-height: .22rem
      color: #333333
    .answer-btn
      position absolute
      // top 4.85rem
      bottom .7rem
      left 50%
      transform translateX(-50%)
      width 2.8rem
      height .54rem
      border-radius .28rem
      color: #E93030
      font-size: .16rem
      background: linear-gradient(to right, #FEBB35, #FEEECE)
      &.high
        bottom 1.66rem

</style>